import { createStore } from 'satcheljs';
export default createStore('appNotificationOption', {
    newMailSound: null,
    newMailToast: null,
    reminderSound: null,
    reminderToast: null,
});
//# sourceMappingURL=store.js.map